export type HtmlKind = "document" | "fragment";

export interface SplitHtml {
  kind: HtmlKind;
  body: string;
}

export function isFullDocument(html: string): boolean {
  return /<html[\s>]/i.test(html);
}

export function splitHtml(html: string): SplitHtml {
  if (!isFullDocument(html)) {
    return { kind: "fragment", body: html };
  }

  const body = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  if (body) return { kind: "document", body: body[1] };

  const stripped = html
    .replace(/<!DOCTYPE[^>]*>/i, "")
    .replace(/<html[^>]*>/i, "")
    .replace(/<\/html>/i, "")
    .replace(/<head[\s\S]*?<\/head>/i, "")
    .trim();

  return { kind: "document", body: stripped };
}

export function joinHtml(original: string, body: string): string {
  if (!isFullDocument(original)) return body;

  if (/<body[^>]*>[\s\S]*<\/body>/i.test(original)) {
    return original.replace(
      /<body([^>]*)>[\s\S]*<\/body>/i,
      (_match, attributes: string) => `<body${attributes}>${body}</body>`,
    );
  }

  if (/<\/html>/i.test(original)) {
    return original.replace(/<\/html>/i, () => `<body>${body}</body></html>`);
  }

  return `${original}\n<body>${body}</body>`;
}
